/**
 * Build the v2 students-query filter from the StudentSelection state.
 *
 * Encodes the AC2/AC3 roster filter rules:
 * - Others enabled            -> cocurriculums only (from selectedGroupOthers).
 * - Filter-from-Subject       -> subjects (+ optional classes).
 * - Plain class               -> classes only.
 * Year is never sent to the v2 students endpoint.
 *
 * @param {object} selection
 * @param {boolean} selection.otherGroupEnabled
 * @param {boolean} selection.filterFromSelectedSubject
 * @param {string[]} selection.selectedGroupSubjects
 * @param {string[]} selection.selectedGroupClasses
 * @param {string[]} selection.selectedGroupOthers
 * @returns {{ subjects?: string, classes?: string, cocurriculums?: string }}
 */
const toCommaSeparated = (values = []) => (values.length > 0 ? values.join(',') : undefined);

const buildStudentListQuery = ({
  otherGroupEnabled,
  filterFromSelectedSubject,
  selectedGroupSubjects = [],
  selectedGroupClasses = [],
  selectedGroupOthers = []
}) => {
  if (otherGroupEnabled) {
    const cocurriculums = toCommaSeparated(selectedGroupOthers);
    return cocurriculums ? { cocurriculums } : {};
  }

  if (filterFromSelectedSubject) {
    const subjects = toCommaSeparated(selectedGroupSubjects);
    const classes = toCommaSeparated(selectedGroupClasses);

    return {
      ...(subjects ? { subjects } : {}),
      ...(classes ? { classes } : {})
    };
  }

  const classes = toCommaSeparated(selectedGroupClasses);
  return classes ? { classes } : {};
};

export default buildStudentListQuery;
